import React, { useEffect, useState, useCallback } from 'react'
import { useNavigation, useRoute } from '@react-navigation/native'
import { StyleSheet, View, Text, SectionList, TouchableOpacity } from 'react-native'
import Icon from '../components/Icon'
import Search from '../components/Search'
import { flatten, map, remove, clone } from 'lodash'
import { t } from 'ttag'
import { HeaderButtons, Item } from 'react-navigation-header-buttons'
import { useAppTheme } from '#app/theme'

export default function ModalPicker () {
  const route = useRoute()
  const navigation = useNavigation()

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type 'Readonly<o... Remove this comment to see the full error message
  const { data, value, search, multiple, required } = route.params

  const theme = useAppTheme()

  const [selectedItem, setSelectedItem] = useState({})
  const [selectedItems, setSelectedItems] = useState([])
  const [checkAll, setCheckAll] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [requiredError, setRequiredError] = useState(false)
  const [totalSelectedItems, setTotalSelectedItems] = useState(0)

  useEffect(() => {
    navigation.setOptions({
      title: '',
      headerRight: (state: any) => {
        return (
          <HeaderButtons>
            <Item
              title={t`Save`}
              iconName="add"
              onPress={goBackAndSave}
            />
          </HeaderButtons>
        )
      }
    })
  })

  useEffect(() => {
    const totalLength = data.reduce((acc: any, section: any) => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      return acc + section.data.length
    }, 0)

    setTotalSelectedItems(totalLength)
    setSearchResults(data)
  }, [data])

  useEffect(() => {
    if (selectedItems.length === totalSelectedItems) {
      setCheckAll(true)
    } else {
      setCheckAll(false)
    }
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedItems])

  useEffect(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    multiple ? setSelectedItems(value) : setSelectedItem(value)
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [value])

  const goBackAndSave = useCallback(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (required && multiple && selectedItems.length === 0) {
      setRequiredError(true)
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    } else if (required && !multiple && (selectedItem as any).value === null) {
      setRequiredError(true)
    } else {
      setRequiredError(false)
      navigation.goBack()

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (multiple) {
        (route.params as any).onPressOk({ selectedItems })
      } else {
        (route.params as any).onPressOk({ selectedItem })
      }
    }
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedItem, selectedItems])

  const _onPressItem = useCallback((item) => {
    setRequiredError(false)
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (multiple) {
      const newSelectedList = clone(selectedItems)
      const exists = selectedItems.some(selected => (selected as any).value === item.value)
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
      exists ? remove(newSelectedList, (e) => (e as any).value === item.value) : newSelectedList.push(item)
      setSelectedItems(newSelectedList)
    } else {
      setSelectedItem(item)
    }
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedItems, selectedItem])

  // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onTrashPress = useCallback(() => {
    setSearchTerm('')
    setSearchResults(data)
  })

  useEffect(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (!searchTerm) {
      setSearchResults(data)
      return
    }

    const newData = data.map((section: any) => {
      return {
        ...section,
        data: section.data.filter((item: any) => {
          return item.label.toLowerCase().includes(searchTerm.toLowerCase())
        })
      }
    })

    setSearchResults(newData)
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [searchTerm])

  const isSelected = useCallback((item) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (multiple) {
      return !!selectedItems.some(selected => (selected as any).value === item.value)
    } else {
      return item.value === (selectedItem as any).value
    }
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedItems, selectedItem])

  const _onPressAll = useCallback(() => {
    if (checkAll) {
      setCheckAll(false)
      setSelectedItems([])
    } else {
      setRequiredError(false)
      setCheckAll(true)
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
      setSelectedItems(flatten(map(data, (section) => section.data)))
    }
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [checkAll])

  const renderPressAll = () => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (multiple && searchTerm.length === 0) {
      return (
        <TouchableOpacity style={theme.list.container} onPress={() => _onPressAll()}>
          <Text style={theme.list.textList}>{t`All Items`}</Text>
          <View style={{ flex: 1, alignSelf: 'center', alignItems: 'flex-end' }}>
            {checkAll && <Icon name="checkmark" size={20} color={theme.textColor} />}
          </View>
        </TouchableOpacity>
      )
    }
    return (<></>)
  }

  const renderItem = ({
    item
  }: any) => {
    return (
      <ItemList item={item} onPress={() => _onPressItem(item)} />
    )
  }

  const renderSection = ({
    section
  }: any) => {
    return (
      <View style={theme.list.separator}>
        <Text style={theme.list.separatorText}>
          {section.title}
        </Text>
      </View>
    )
  }

  const ItemList = ({
    item,
    onPress,
    style
  }: any) => (
    <>
      <TouchableOpacity style={[theme.list.container, style]} onPress={onPress}>
        <Text style={theme.list.textList}>{item.label}</Text>
        <View style={{ flex: 1, alignSelf: 'center', alignItems: 'flex-end' }}>
          {isSelected(item) && <Icon name="checkmark" size={20} color={theme.textColor} />}
        </View>
      </TouchableOpacity>
      <View style={theme.list.borderBottom} />
    </>
  )

  return (
      <View style={[styles.wrapper]}>
        {requiredError && (
          <View style={{ backgroundColor: '#C45A5A', padding: 10 }}>
            <Text style={{ color: '#fff', textAlign: 'center' }}>
              {t`Select at least one item!`}
            </Text>
          </View>
        )}

        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line @typescript-eslint/strict-boolean-expressions */}
        {search && (
          <Search
            placeholder={t`Search...`}
            placeholderTextColor="white"
            style={[styles.searchBox, { backgroundColor: theme.formForm.search }]}
            value={searchTerm}
            valueTextColor={theme.textColor}
            onChangeText={setSearchTerm}
            onTrashPress={onTrashPress}
            iconColor={theme.formForm.searchIconColor}
          />
        )}
        <SectionList
          sections={searchResults}
          horizontal={false}
          stickySectionHeadersEnabled
          renderSectionHeader={renderSection}
          renderItem={renderItem}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          extraData={multiple ? selectedItems : selectedItem}
          ListHeaderComponent={renderPressAll}
          keyExtractor={(item, index) => `${index}`}
        />
      </View>
  )
}

const styles = StyleSheet.create({
  searchBox: {
    flexDirection: 'row',
    paddingLeft: 10,
    paddingRight: 10,
    height: 40
  },
  searchWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 15,
    paddingTop: 7.5,
    paddingBottom: 7.5
  },
  wrapper: {
    width: '100%',
    height: '100%'
  }
})
